import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./analytics";

const DEFAULT_META = {
  title: "InstantTranscriber App",
  description: "Upload, record, and manage fast AI audio and video transcripts in InstantTranscriber.",
};

const ROUTE_META = [
  {
    match: (pathname) => pathname === "/login",
    title: "Sign in to InstantTranscriber",
    description: "Sign in to upload, record, and manage transcripts in InstantTranscriber.",
  },
  {
    match: (pathname) => pathname === "/signup",
    title: "Create an InstantTranscriber Account",
    description: "Create an account to transcribe audio and video files with InstantTranscriber.",
  },
  {
    match: (pathname) => pathname === "/reset-password",
    title: "Reset Password | InstantTranscriber",
    description: "Reset your InstantTranscriber password and return to your transcript dashboard.",
  },
  {
    match: (pathname) => pathname.startsWith("/dashboard"),
    title: "Transcript Dashboard | InstantTranscriber",
    description: "Upload, record, review, and export your InstantTranscriber transcripts.",
  },
  {
    match: (pathname) => pathname.startsWith("/admin"),
    title: "Admin Dashboard | InstantTranscriber",
    description: "InstantTranscriber administration dashboard.",
  },
];

function setMetaDescription(content) {
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "description");
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

function setRouteMetadata(pathname) {
  const meta = ROUTE_META.find((entry) => entry.match(pathname)) || DEFAULT_META;
  document.title = meta.title;
  setMetaDescription(meta.description);
}

export default function AnalyticsRouteTracker() {
  const location = useLocation();
  const lastPathRef = useRef("");

  useEffect(() => {
    setRouteMetadata(location.pathname);
    // OAuth request tickets and callback state never belong in analytics URLs.
    if (location.pathname.startsWith('/mcp/')) return;

    const path = `${location.pathname}${location.search}`;
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;

    const timer = window.setTimeout(() => {
      trackPageView(path);
    }, 0);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
